import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const STORAGE_KEY = "parakox_cookie_consent_v1";

function applyConsent(status) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  const grant = status === "granted";
  window.gtag("consent", "update", {
    ad_storage: grant ? "granted" : "denied",
    ad_user_data: grant ? "granted" : "denied",
    ad_personalization: grant ? "granted" : "denied",
    analytics_storage: grant ? "granted" : "denied",
    functionality_storage: grant ? "granted" : "denied",
    personalization_storage: grant ? "granted" : "denied",
    security_storage: "granted",
  });
}

export default function CookieBanner() {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        setVisible(true);
      } else {
        applyConsent(saved);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const persist = (status) => {
    try {
      localStorage.setItem(STORAGE_KEY, status);
    } catch (e) {
      // ignore
    }
    applyConsent(status);
    setVisible(false);
  };

  const lang = i18n.language === "en" ? "en" : "pe";

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-2xl"
      role="dialog"
      aria-live="polite"
      aria-label={t("cookie_banner.title")}
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <p
            className="text-sm font-semibold text-slate-900"
            style={{ fontFamily: "Merriweather, serif" }}
          >
            {t("cookie_banner.title")}
          </p>
          <p className="mt-1 text-sm text-slate-600 leading-relaxed">
            {t("cookie_banner.body")}{" "}
            <Link
              to={`/${lang}/cookies`}
              className="underline text-slate-900 hover:text-[#0B1D3A]"
              data-testid="cookie-banner-learn-more"
            >
              {t("cookie_banner.learn_more")}
            </Link>
          </p>
        </div>
        <div className="flex flex-shrink-0 gap-2">
          <button
            type="button"
            onClick={() => persist("denied")}
            className="px-4 py-2 rounded-md border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50"
            data-testid="cookie-banner-reject"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            type="button"
            onClick={() => persist("granted")}
            className="px-4 py-2 rounded-md text-white text-sm font-semibold"
            style={{ backgroundColor: "#10B981" }}
            data-testid="cookie-banner-accept"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
}
